import type { TaskType } from '../_types/form'
import type { PromptMode } from '@loc/server/interface/task'

export interface IAiThinkingInfo {
  channelId: string
  reasoningContent: IContent
  lyricsContent: IContent
}

export interface IContent {
  content: string
}
export interface IPolishPromptItem {
  class: string
  text: string
}

export interface Recommend {
  prompt: string
  title: string
  rating: number
}
export interface State {
  aiThinkingInfo: IAiThinkingInfo
  lyricsTextareaContent: string
  polishPrompt: IPolishPromptItem[]
  isStream: boolean
  aiIdeasModalOpen: boolean
  moreIdeasModalOpen: boolean
  lyricsGeneratorAbortController: AbortController | null
  thinkingTime: number
  thinkingTimeinterval: NodeJS.Timeout | null
  recommends: Recommend[]
  customRecommends: Recommend[]
  aiPolishPromptContent: string[]
  aiIdeasAreaShow: boolean
  aiThinkingAreaShow: boolean
  aiLyriceAreaShow: boolean
  aiThinkingContentExpand: boolean
  styleShow: boolean
  aiCreateBtnShow: boolean
  lyricsCustomTextareaContent: string
  reloadRecommend: boolean
  finalTaskType: TaskType
  finalImageUrl: string
  finalPromptSelectMode: PromptMode
  finalPrompt: string
  isFirstClickGenerateLyricsSmart: boolean
  generateLyricsSmartAreaCollapsed: boolean
}

export const initialState: State = {
  // ai思考过程的数据结构
  aiThinkingInfo: {
    channelId: '',
    reasoningContent: {
      content: '',
    },
    lyricsContent: {
      content: '',
    },
  },
  // 歌词文本框的内容，单独字段，可修改，不影响ai思考返回的歌词字段
  lyricsTextareaContent: '',
  polishPrompt: [],
  isStream: false, // 是否是流式生成，ai思考开始结束的标志
  aiIdeasModalOpen: false,
  moreIdeasModalOpen: false,
  lyricsGeneratorAbortController: null,
  thinkingTime: 0,
  thinkingTimeinterval: null,
  recommends: [],
  customRecommends: [],
  aiPolishPromptContent: [], // ai优化歌词的建议
  aiIdeasAreaShow: true, // ai建议区域是否展示
  aiThinkingAreaShow: false, // ai思考区域是否展示
  aiThinkingContentExpand: true, // ai思考内容是否展开
  aiLyriceAreaShow: false, // ai歌词区域是否展示
  styleShow: false,
  aiCreateBtnShow: false,
  lyricsCustomTextareaContent: '',
  reloadRecommend: false,
  finalTaskType: 'Song', // 最终提交的tasktype
  finalImageUrl: '', // 最终提交的imageurl
  finalPromptSelectMode: 'smart' as PromptMode, // 最终提交的promptSelectMode
  finalPrompt: '', // 最终提交的prompt
  isFirstClickGenerateLyricsSmart: true, // 是否是首次点击智能生成歌词按钮
  generateLyricsSmartAreaCollapsed: false, // 智能生成歌词区域是否收起
}
